<template>
  <section class="conversation-page bg-white dark:bg-slate-900">
    <chat-list
      v-if="!singleMode /* d99d */"
      :conversation-inbox="inboxId"
      :label="label"
      :team-id="teamId"
      :conversation-type="conversationType"
      :folders-id="foldersId"
      :chat="currentChat"
      @conversation-load="onConversationLoad"
    />
    <empty-state
      v-if="uiFlags.isFetching || loadingChatList || !conversationId"
    />
    <template v-else>
      <mail-box
        v-if="showMailBoxView"
        :inbox-id="inboxId"
        :is-contact-panel-open="isContactPanelOpen"
        @contact-panel-toggle="onToggleContactPanel"
        @contact-panel-off="offContactPanel"
      />
      <message-box
        v-if="showMessageView"
        :inbox-id="inboxId"
        :is-contact-panel-open="isContactPanelOpen"
        @contact-panel-toggle="onToggleContactPanel"
        @contact-panel-off="offContactPanel"
      />
    </template>
  </section>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { BUS_EVENTS } from 'shared/constants/busEvents';

import ChatList from 'dashboard/routes/dashboard/conversation/ChatList/Index.vue';
import MessageBox from 'dashboard/routes/dashboard/conversation/MessageBox/Index.vue';
import MailBox from 'dashboard/routes/dashboard/conversation/Mailbox/Index.vue';
import EmptyState from 'dashboard/components/widgets/conversation/EmptyState/EmptyState.vue';

import uiSettingsMixin from 'dashboard/mixins/uiSettings';
import inboxMixin from 'shared/mixins/inboxMixin';
import wootConstants from 'dashboard/constants/globals';

export default {
  components: {
    ChatList,
    MailBox,
    MessageBox,
    EmptyState,
  },
  mixins: [uiSettingsMixin, inboxMixin],
  props: {
    inboxId: {
      type: [String, Number],
      default: 0,
    },
    conversationId: {
      type: [String, Number],
      default: 0,
    },
    // d99d
    singleMode: {
      type: Boolean,
      default: false,
    },
    // .
    label: {
      type: String,
      default: '',
    },
    teamId: {
      type: String,
      default: '',
    },
    conversationType: {
      type: String,
      default: '',
    },
    foldersId: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      showSearchModal: false,
    };
  },
  computed: {
    ...mapGetters({
      chatList: 'getAllConversations',
      currentChat: 'getSelectedChat',
      uiFlags: 'inboxes/getUIFlags',
      loadingChatList: 'getChatListLoadingStatus',
    }),
    inbox() {
      if (this.currentChat)
        return this.$store.getters['inboxes/getInbox'](
          this.currentChat.inbox_id
        );
      return null;
    },
    isConversationLoaded() {
      return (
        this.conversationId && this.currentChat?.id && this.inbox?.channel_type
      );
    },
    showMailBoxView() {
      return this.isConversationLoaded && this.isAnEmailChannel;
    },
    showMessageView() {
      return this.isConversationLoaded && !this.isAnEmailChannel;
    },
    isContactPanelOpen() {
      if (this.currentChat.id) {
        const { is_contact_sidebar_open: isContactSidebarOpen } =
          this.uiSettings;
        return isContactSidebarOpen;
      }
      return false;
    },
  },
  watch: {
    conversationId() {
      this.fetchConversationIfUnavailable();
      this.fetchAgents();
    },
  },
  async mounted() {
    this.fetchAgents();
    this.initialize();
    this.$watch('$store.state.route', () => this.initialize());
    this.$watch('chatList.length', () => {
      this.setActiveChat();
    });

    // d99d
    if (this.singleMode) {
      this.$store.dispatch('teams/get');
      if (!this.$store.getters['inboxes/getInboxes'].length)
        await this.$store.dispatch('inboxes/get');
      await this.$store.dispatch('getConversation', this.conversationId);
      this.$store.commit('CLEAR_LIST_LOADING_STATUS');
      Vue.set(this.currentChat, 'dataFetched', true); // todo because there is some glitch - infinity loader in MessageView
    }
    // .
  },

  // d99d
  created() {
    bus.$on('setActiveChatOnMessage', this.setActiveChat);
  },

  destroyed() {
    bus.$off('setActiveChatOnMessage', this.setActiveChat);
  },
  // .

  methods: {
    onConversationLoad() {
      this.fetchConversationIfUnavailable();
    },
    initialize() {
      this.$store.dispatch('setActiveInbox', this.inboxId);
      this.setActiveChat();
    },
    toggleConversationLayout() {
      const { LAYOUT_TYPES } = wootConstants;
      const {
        conversation_display_type:
          conversationDisplayType = LAYOUT_TYPES.CONDENSED,
      } = this.uiSettings;
      const newViewType =
        conversationDisplayType === LAYOUT_TYPES.CONDENSED
          ? LAYOUT_TYPES.EXPANDED
          : LAYOUT_TYPES.CONDENSED;
      this.updateUISettings({
        conversation_display_type: newViewType,
        previously_used_conversation_display_type: newViewType,
      });
    },
    fetchConversationIfUnavailable() {
      if (!this.conversationId) {
        return;
      }
      const chat = this.findConversation();
      if (!chat) {
        this.$store.dispatch('getConversation', this.conversationId);
      }
    },
    fetchAgents() {
      const params = this.inboxId ? { inbox_id: this.inboxId } : {};
      this.$store.dispatch('agents/get', params);
    },
    findConversation() {
      const conversationId = parseInt(this.conversationId, 10);
      const [chat] = this.chatList.filter(c => c.id === conversationId);
      return chat;
    },
    setActiveChat(messageIdToPos) {
      if (this.conversationId) {
        const selectedConversation = this.findConversation();
        // If conversation doesn't exist or selected conversation is same as the active
        // conversation, don't set active conversation.
        if (
          !selectedConversation ||
          (selectedConversation.id === this.currentChat.id && !messageIdToPos) // d99d
        ) {
          return;
        }
        let { messageId } = this.$route.query;
        // d99d
        if (messageIdToPos) {
          if (
            !selectedConversation.messages.find(x => x.id === messageIdToPos)
          ) {
            selectedConversation.dataFetched = undefined; // to reload this message
          }
          messageId = messageIdToPos;
        }
        // .
        this.$store
          .dispatch('setActiveChat', {
            data: selectedConversation,
            after: messageId,
          })
          .then(() => {
            bus.$emit(BUS_EVENTS.SCROLL_TO_MESSAGE, { messageId });
          });
      } else {
        this.$store.dispatch('clearSelectedState');
      }
    },
    onToggleContactPanel() {
      this.updateUISettings({
        is_contact_sidebar_open: !this.isContactPanelOpen,
      });
    },
    offContactPanel() {
      this.updateUISettings({
        is_contact_sidebar_open: false,
      });
    },
    onSearch() {
      this.showSearchModal = true;
    },
    closeSearch() {
      this.showSearchModal = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.conversation-page {
  display: flex;
  width: 100%;
  height: 100%;
}
</style>
